import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/home/bilibili-winter-view-1.f67d9ca8.jpg'
import _imports_1 from '@/assets/img/home/bilibili-winter-view-2.ba9c6589.jpg'
import _imports_2 from '@/assets/video/home/bilibili-winter-view-3.79f65a9c.webm'
import _imports_3 from '@/assets/img/home/bilibili-winter-view-3-snow.c5bca8d6.png'
import _imports_4 from '@/assets/img/home/bilibili-winter-tree-1.bff9a60f.png'
import _imports_5 from '@/assets/img/home/bilibili-winter-tree-2.5f90f1cb.png'
import _imports_6 from '@/assets/img/home/bilibili-winter-tree-3.77be716a.png'


const _hoisted_1 = { id: "Header" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"\" class=\"morning\"><img src=\"" + _imports_1 + "\" alt=\"\" class=\"afternoon\"><video autoplay loop muted class=\"evening\"><source src=\"" + _imports_2 + "\" type=\"video/webm\"></video><img src=\"" + _imports_3 + "\" alt=\"\" class=\"window-cover\">", 4)
const _hoisted_6 = [
  _hoisted_2
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "morning"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "afternoon"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  class: "evening"
}, null, -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]


const __default__ = { name: 'HomeHeader' };

import {reactive, ref, onBeforeMount, onMounted, onUnmounted, computed} from 'vue';
// import { throttle } from '@/helpers/helpers';

// 是否在滑动（是否开启is-moving这个类）

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

// import '@/assets/svg/home-svg/fonticon/iconfont.css';
const isMoving = ref(false);
// 默认0.5，显示中间那张图
const opacity = ref(0.5);
// 拿到ref上的这个dom
const homeHeader = ref();
// 拿到头部的宽度 === 浏览器宽度
const homeHeaderWidth = ref(window.innerWidth);
// 定义鼠标第一次进入头部图片的位置
let startX = 0;

// const windowScrollHeight = ref();
// const navHeight = ref();

// 鼠标在图片上滑动
const headerMousemove = (e: MouseEvent) => {
  // console.log(homeHeaderWidth.value);
  opacity.value = (e.clientX - startX) / homeHeaderWidth.value + 0.5;
  isMoving.value = true;
};
// 拿到鼠标进入图片时的位置
const headerMouseenter = (e: MouseEvent) => {
  startX = e.clientX;
}
// 离开图片时回到默认值
const handerMouseleave = (e: MouseEvent) => {
  isMoving.value = false;
  opacity.value = 0.5;
}
// 拿到当前屏幕的宽度
const handleResize = () => {
  homeHeaderWidth.value = homeHeader.value.offsetWidth;
}
// const headerScroll = () => {
//   windowScrollHeight.value = window.pageYOffset;
// }
// const isScroll = computed(() => {
//   return  windowScrollHeight.value >=navHeight.value
// })
onMounted(() => {
  // navHeight.value = nav.value.offsetHeight
  handleResize()
  // 在浏览器页面大小发生改变时触发
  window.addEventListener('resize', handleResize)
  // window.addEventListener('scroll', headerScroll)
});

onUnmounted(()=>{
  window.removeEventListener('resize', handleResize)
})

expose({
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "home-header",
    ref_key: "homeHeader",
    ref: homeHeader,
    onMousemove: headerMousemove,
    onMouseenter: headerMouseenter,
    onMouseleave: handerMouseleave
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", {
        class: "",
        style: _normalizeStyle(`--percentage:${opacity.value}; --full-width: ${homeHeaderWidth.value}`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`view ${isMoving.value ? 'is-moving' : ''}`)
        }, _hoisted_6, 2),
        _createElementVNode("div", {
          class: _normalizeClass(`tree ${isMoving.value ? 'is-moving' : ''}`)
        }, _hoisted_10, 2)
      ], 4)
    ])
  ], 544))
}
}

})